import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { ReferenceSchema } from '../../../../expressions/validation/ReferenceSchema.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../../inputs/common/CommonInputConfigComponent.tsx';
import { RepeatableListSelectInput } from './components/RepeatableListSelectInput.tsx';
import {
  type IRepeatControllerWidget,
  RepeatControllerComponentType,
} from './IRepeatControllerWidget.ts';

export const RepeatControllerConfigSchema: yup.ObjectSchema<IRepeatControllerWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.RepeatController).required(),
    kind: yup
      .string()
      .oneOfEnum(RepeatControllerComponentType)
      .required()
      .default(RepeatControllerComponentType.Input)
      .label('Tipo di input'),
    listReference: ReferenceSchema.required().label('Riferimento lista'),
    confirmReduce: yup.boolean().default(true).label('Conferma eliminazione'),
  });

export interface IRepeatControllerWidgetConfigComponentProps
  extends IWidgetComponentProps<IRepeatControllerWidget> {}

export function RepeatControllerWidgetConfigComponent(
  props: IRepeatControllerWidgetConfigComponentProps,
) {
  return (
    <>
      <RepeatableListSelectInput />
      <CommonConfigComponent {...props} noConfirmation={true} />
      <FormItem
        name="confirmReduce"
        label="Conferma eliminazione"
        help="Richiedi all'utente conferma prima di ridurre il numero di elementi della lista."
      >
        <CheckboxInput name="confirmReduce" defaultChecked={true}>
          Richiedi la conferma
        </CheckboxInput>
      </FormItem>
    </>
  );
}
